import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/ui/Modal';
import { FormattedMessage } from 'react-intl';
import { StyledColumn } from '../AfterSalesWarning.styles';
import { CancelButton } from 'components/ui/Button';
import { Row } from 'components/shared/Layout';
import { POINTS_REDEMPTION_MISMATCH_KEY } from 'constants/clubEurostar';

const PointsMismatchWarning = ({ isOpen, closeModal }) => {
  const mismatchContext = JSON.parse(localStorage.getItem(POINTS_REDEMPTION_MISMATCH_KEY));

  const onDefaultClose = () => {
    closeModal(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onDefaultClose}>
      <FormattedMessage id="journeys.redeemedPointsMismatch.title" />

      <br />
      <br />

      <FormattedMessage
        id="journeys.redeemedPointsMismatch.points"
        values={{
          expected: <strong>{mismatchContext.expected}</strong>,
          redeemed: <strong>{mismatchContext.redeemed}</strong>
        }}
      />

      <Row>
        <StyledColumn span={3}>
          <CancelButton
            data-cy="cancel"
            onClick={() => {
              closeModal(true);
            }}
          >
            <FormattedMessage id="journeys.redeemedPointsMismatch.statement.cta" />
          </CancelButton>
        </StyledColumn>
      </Row>
    </Modal>
  );
};

PointsMismatchWarning.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func
};

export default PointsMismatchWarning;
